import { render, staticRenderFns } from "./CustomerMatchSummaryNet.vue?vue&type=template&id=81ee1d90"
import script from "./CustomerMatchSummaryNet.vue?vue&type=script&lang=ts"
export * from "./CustomerMatchSummaryNet.vue?vue&type=script&lang=ts"
import style0 from "./CustomerMatchSummaryNet.vue?vue&type=style&index=0&id=81ee1d90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports